module.exports = __webpack_public_path__ + "static/media/icon_o.04497df0.svg";